import { Beheaded } from '../../Beheaded';
import { ArrayHelper } from '../../../core/utils/ArrayHelper';
import { BeheadedSymbolData } from './BeheadedSymbolData';

export class BeheadedRope extends PIXI.Container {
    private readonly ropePath: string = 'ui/reelDividers/div';
    private readonly ropeEndPath: string = 'ui/reelDividers/div-end';

    private rope: PIXI.Sprite[] = [];
    private ropeSize: number = 4;

    constructor() {
        super();
        this.Init();
    }

    Init(): void {
        this.buildRope();
    }

    cut(): void {
        if(this.rope.length){
            ArrayHelper.fetchLastValue(this.rope).texture = Beheaded.assetLoader.getTextures(this.ropeEndPath)[0];
        }
    }

    getSingleRope(indx: number): PIXI.Sprite {
        return this.rope[indx];
    }

    fetchRope(indx: number): PIXI.Sprite[] {
        const ropeThatHaveBeenCutOut: PIXI.Sprite[] = [];
        for (let i = 0; i < this.ropeSize - indx; i++) {
            ropeThatHaveBeenCutOut.push(this.rope.pop()!);
        }
        return ropeThatHaveBeenCutOut;
    }

    buildRope(): void {

        while (this.rope.length <= this.ropeSize) {
            const rope = this.addChild(new PIXI.Sprite());
            rope.anchor.set(0.5, 0.5);
            this.rope.push(rope);
        }
        
        this.rope.forEach((r, i) => {
            r.y = (i - 1) * BeheadedSymbolData.DEFAULT_DIM.HEIGHT;
            r.texture = Beheaded.assetLoader.getTextures(this.rope.length - 1 == i ? this.ropeEndPath : this.ropePath)[0];
            r.height = BeheadedSymbolData.DEFAULT_DIM.HEIGHT;
        });
    }
}
